import React from 'react';
import { useBalanceVisibility } from '../contexts/BalanceVisibilityContext';

// Largura fixa de propósito: sempre os mesmos 4 pontos, independente do valor real, para não
// vazar a ordem de grandeza pelo comprimento da máscara.
const MASCARA = '••••';

const MaskedValue = ({ children }) => {
  const { hidden } = useBalanceVisibility();

  if (!hidden) {
    return children;
  }

  return <span aria-label="valor oculto">{MASCARA}</span>;
};

export default MaskedValue;
